
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as index3EBbwWtE9NCeEzLI7T0l_xSanHKPhY83Lj7XPjBcsdEMeta } from "/opt/build/repo/src/pages/index.vue?macro=true";
import { default as _91_46_46_46all_93hLDtDYpGr2_2nc1_45KgMSWuYz74ttkQoqjob_45iqkz3MMMeta } from "/opt/build/repo/src/pages/[...all].vue?macro=true";
import { default as contatti_uPXZWHlEqKlLia9jnKKQBZ0vxqmMndZqp8OTR_45IdAwMeta } from "/opt/build/repo/src/pages/contatti.vue?macro=true";
import { default as _91id_93C4ewlD4i7jzUu6R0pqUlkcaQuRu3x6SjhzMLdv1V_4sMeta } from "/opt/build/repo/src/pages/blog/[id].vue?macro=true";
import { default as gridtPwuZeJZcuE_45JTYi_xn_45_SzH_du2flX3E3eju8UjZIcMeta } from "/opt/build/repo/src/pages/blog/grid.vue?macro=true";
import { default as chi_45siamodrS6RM_utT_cJFDS_454pcNK_45EhPrSywAZUJH_45P0yMZekMeta } from "/opt/build/repo/src/pages/chi-siamo.vue?macro=true";
import { default as not_45foundi6ixjpyNPLIvbEo7GunE81jjWq77NAyuOqOuZl0vEPEMeta } from "/opt/build/repo/src/pages/not-found.vue?macro=true";
import { default as indexxTdPeZKjmWsyvzdOe1WeQb7WvPzE31wJhiRO5xE9z6sMeta } from "/opt/build/repo/src/pages/blog/index.vue?macro=true";
import { default as accessibilitamMLAteeY4Rk5eyEGmNY568EyZAkTlizoF3ZZyM1O1SgMeta } from "/opt/build/repo/src/pages/accessibilita.vue?macro=true";
import { default as cookie_45policy2PIrzGBJ4bcUdZL8Xx_451ndxJkrIdU1EmLVvSUZjinZ4Meta } from "/opt/build/repo/src/pages/cookie-policy.vue?macro=true";
import { default as lavora_45con_45noiaOdbvQMNOZVWgg_45HfPFd_3PmlRBdJ_h98hYmwqc75i0Meta } from "/opt/build/repo/src/pages/lavora-con-noi.vue?macro=true";
import { default as privacy_45policy_PSianptQE8DE5pCWhLP2mv4P8372QTnxgjAqnvTkFEMeta } from "/opt/build/repo/src/pages/privacy-policy.vue?macro=true";
import { default as prismic_45previewv2q3IVyx8dwPZhClFK_Fdy_452ihuoNeHMwc4SzYUEh40Meta } from "/opt/build/repo/src/pages/prismic-preview.vue?macro=true";
import { default as termini_45e_45condizioniehqJSgSLeu2SPAOTcgdYlRfML9V5pCl_khkOh8mbs4YMeta } from "/opt/build/repo/src/pages/termini-e-condizioni.vue?macro=true";
import { default as _91id_93BU08mga_kuyOWiNIU9tAF2J9BlB12q_3NS53q59c75gMeta } from "/opt/build/repo/src/pages/categoria/energia/[id].vue?macro=true";
import { default as indexa3etV5g4weKVIEPQBk7ofXcNR6VypjpwIk8OWSvI5pMMeta } from "/opt/build/repo/src/pages/categoria/energia/index.vue?macro=true";
import { default as _91id_9358zb40Bt3d3jtIwecGevAdMkhJTj2yu8Z_45NwospROk4Meta } from "/opt/build/repo/src/pages/categoria/telefonia/[id].vue?macro=true";
import { default as index7uNi6li6h_50HrgOwhDjyYRl59VsE5g3gxPs4ghIvZAMeta } from "/opt/build/repo/src/pages/categoria/telefonia/index.vue?macro=true";
import { default as come_45funziona_45risparmia_45tu8_451HwmOpYfxzMPpGYgdBDBRBXcSFbTkM_WVE8tLieS8Meta } from "/opt/build/repo/src/pages/come-funziona-risparmia-tu.vue?macro=true";
import { default as _91id_93xQS1IEn7wrPEZW1mmomG64W37hzvMgPdq_45qqu8oe3l4Meta } from "/opt/build/repo/src/pages/categoria/assicurazioni/[id].vue?macro=true";
import { default as indexk9uSPlyNZdrjKwhJfAdtI0nGjlzqYRChZ_456HVxPsrooMeta } from "/opt/build/repo/src/pages/categoria/assicurazioni/index.vue?macro=true";
import { default as component_45stuby_45p6a6ltR2_45wfQ0XP1gvsKSSIEKWALr_454XMlA1w5XqIMeta } from "/opt/build/repo/node_modules/.pnpm/nuxt@3.21.11_@netlify+blobs@8.2.0_@oxc-project+types@0.143.0_@parcel+watcher@2.6.0_@types+nod_6ov5qllacxytyqciuuaqdxie5q/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stuby_45p6a6ltR2_45wfQ0XP1gvsKSSIEKWALr_454XMlA1w5XqI } from "/opt/build/repo/node_modules/.pnpm/nuxt@3.21.11_@netlify+blobs@8.2.0_@oxc-project+types@0.143.0_@parcel+watcher@2.6.0_@types+nod_6ov5qllacxytyqciuuaqdxie5q/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: index3EBbwWtE9NCeEzLI7T0l_xSanHKPhY83Lj7XPjBcsdEMeta || {},
    component: () => import("/opt/build/repo/src/pages/index.vue")
  },
  {
    name: "all",
    path: "/:all(.*)*",
    meta: _91_46_46_46all_93hLDtDYpGr2_2nc1_45KgMSWuYz74ttkQoqjob_45iqkz3MMMeta || {},
    component: () => import("/opt/build/repo/src/pages/[...all].vue")
  },
  {
    name: "contatti",
    path: "/contatti",
    meta: contatti_uPXZWHlEqKlLia9jnKKQBZ0vxqmMndZqp8OTR_45IdAwMeta || {},
    component: () => import("/opt/build/repo/src/pages/contatti.vue")
  },
  {
    name: "blog-id",
    path: "/blog/:id()",
    meta: _91id_93C4ewlD4i7jzUu6R0pqUlkcaQuRu3x6SjhzMLdv1V_4sMeta || {},
    component: () => import("/opt/build/repo/src/pages/blog/[id].vue")
  },
  {
    name: "blog-grid",
    path: "/blog/grid",
    meta: gridtPwuZeJZcuE_45JTYi_xn_45_SzH_du2flX3E3eju8UjZIcMeta || {},
    component: () => import("/opt/build/repo/src/pages/blog/grid.vue")
  },
  {
    name: "chi-siamo",
    path: "/chi-siamo",
    meta: chi_45siamodrS6RM_utT_cJFDS_454pcNK_45EhPrSywAZUJH_45P0yMZekMeta || {},
    component: () => import("/opt/build/repo/src/pages/chi-siamo.vue")
  },
  {
    name: "not-found",
    path: "/not-found",
    component: () => import("/opt/build/repo/src/pages/not-found.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexxTdPeZKjmWsyvzdOe1WeQb7WvPzE31wJhiRO5xE9z6sMeta || {},
    component: () => import("/opt/build/repo/src/pages/blog/index.vue")
  },
  {
    name: "accessibilita",
    path: "/accessibilita",
    meta: accessibilitamMLAteeY4Rk5eyEGmNY568EyZAkTlizoF3ZZyM1O1SgMeta || {},
    component: () => import("/opt/build/repo/src/pages/accessibilita.vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    meta: cookie_45policy2PIrzGBJ4bcUdZL8Xx_451ndxJkrIdU1EmLVvSUZjinZ4Meta || {},
    component: () => import("/opt/build/repo/src/pages/cookie-policy.vue")
  },
  {
    name: "lavora-con-noi",
    path: "/lavora-con-noi",
    meta: lavora_45con_45noiaOdbvQMNOZVWgg_45HfPFd_3PmlRBdJ_h98hYmwqc75i0Meta || {},
    component: () => import("/opt/build/repo/src/pages/lavora-con-noi.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policy_PSianptQE8DE5pCWhLP2mv4P8372QTnxgjAqnvTkFEMeta || {},
    component: () => import("/opt/build/repo/src/pages/privacy-policy.vue")
  },
  {
    name: "prismic-preview",
    path: "/prismic-preview",
    meta: prismic_45previewv2q3IVyx8dwPZhClFK_Fdy_452ihuoNeHMwc4SzYUEh40Meta || {},
    component: () => import("/opt/build/repo/src/pages/prismic-preview.vue")
  },
  {
    name: "termini-e-condizioni",
    path: "/termini-e-condizioni",
    meta: termini_45e_45condizioniehqJSgSLeu2SPAOTcgdYlRfML9V5pCl_khkOh8mbs4YMeta || {},
    component: () => import("/opt/build/repo/src/pages/termini-e-condizioni.vue")
  },
  {
    name: "categoria-energia-id",
    path: "/categoria/energia/:id()",
    component: () => import("/opt/build/repo/src/pages/categoria/energia/[id].vue")
  },
  {
    name: "categoria-energia",
    path: "/categoria/energia",
    component: () => import("/opt/build/repo/src/pages/categoria/energia/index.vue")
  },
  {
    name: "categoria-telefonia-id",
    path: "/categoria/telefonia/:id()",
    component: () => import("/opt/build/repo/src/pages/categoria/telefonia/[id].vue")
  },
  {
    name: "categoria-telefonia",
    path: "/categoria/telefonia",
    component: () => import("/opt/build/repo/src/pages/categoria/telefonia/index.vue")
  },
  {
    name: "come-funziona-risparmia-tu",
    path: "/come-funziona-risparmia-tu",
    meta: come_45funziona_45risparmia_45tu8_451HwmOpYfxzMPpGYgdBDBRBXcSFbTkM_WVE8tLieS8Meta || {},
    component: () => import("/opt/build/repo/src/pages/come-funziona-risparmia-tu.vue")
  },
  {
    name: "categoria-assicurazioni-id",
    path: "/categoria/assicurazioni/:id()",
    component: () => import("/opt/build/repo/src/pages/categoria/assicurazioni/[id].vue")
  },
  {
    name: "categoria-assicurazioni",
    path: "/categoria/assicurazioni",
    component: () => import("/opt/build/repo/src/pages/categoria/assicurazioni/index.vue")
  },
  {
    name: component_45stuby_45p6a6ltR2_45wfQ0XP1gvsKSSIEKWALr_454XMlA1w5XqIMeta?.name,
    path: "/cookie-policy-e-privacy",
    component: component_45stuby_45p6a6ltR2_45wfQ0XP1gvsKSSIEKWALr_454XMlA1w5XqI
  },
  {
    name: component_45stuby_45p6a6ltR2_45wfQ0XP1gvsKSSIEKWALr_454XMlA1w5XqIMeta?.name,
    path: "/privacy-e-cookie-policy",
    component: component_45stuby_45p6a6ltR2_45wfQ0XP1gvsKSSIEKWALr_454XMlA1w5XqI
  },
  {
    name: component_45stuby_45p6a6ltR2_45wfQ0XP1gvsKSSIEKWALr_454XMlA1w5XqIMeta?.name,
    path: "/lista-degli-sponsor",
    component: component_45stuby_45p6a6ltR2_45wfQ0XP1gvsKSSIEKWALr_454XMlA1w5XqI
  },
  {
    name: component_45stuby_45p6a6ltR2_45wfQ0XP1gvsKSSIEKWALr_454XMlA1w5XqIMeta?.name,
    path: "/assistenza",
    component: component_45stuby_45p6a6ltR2_45wfQ0XP1gvsKSSIEKWALr_454XMlA1w5XqI
  },
  {
    name: component_45stuby_45p6a6ltR2_45wfQ0XP1gvsKSSIEKWALr_454XMlA1w5XqIMeta?.name,
    path: "/ricerca_selezione_personale",
    component: component_45stuby_45p6a6ltR2_45wfQ0XP1gvsKSSIEKWALr_454XMlA1w5XqI
  }
]